/* globals MarkerClusterer InfoBox*/

import {helpers} from '../common/helpers';
import googleMapsLoader from 'google-maps';

let poiIconSet = {
	park: '/assets/public/images/map-markers/poi-park.svg',
	beauty: '/assets/public/images/map-markers/poi-beauty.svg',
	stores: '/assets/public/images/map-markers/poi-stores.svg',
	market: '/assets/public/images/map-markers/poi-market.svg',
	clothes: '/assets/public/images/map-markers/poi-clothes.svg',
	food: '/assets/public/images/map-markers/poi-food.svg',
	school: '/assets/public/images/map-markers/poi-school.svg',
	sport: '/assets/public/images/map-markers/poi-sport.svg',
	med: '/assets/public/images/map-markers/poi-med.svg',
};

let hoverMarkersLoaded;
let hoverMarkers = [
	'/assets/public/images/map-markers/placemark-hov.svg',
	'/assets/public/images/map-markers/placemark-black-hov.svg',
	'/assets/public/images/map-markers/placemark-futuro-hov.svg',
	'/assets/public/images/map-markers/placemark-avenue-hov.svg',
	'/assets/public/images/map-markers/placemark-fonte-hov.svg',
	'/assets/public/images/map-markers/marker-opened.svg',
	'/assets/public/images/map-markers/poi-hov.svg',
	'/assets/public/images/map-markers/poi-park-hov.svg',
	'/assets/public/images/map-markers/poi-beauty-hov.svg',
	'/assets/public/images/map-markers/poi-stores-hov.svg',
	'/assets/public/images/map-markers/poi-market-hov.svg',
	'/assets/public/images/map-markers/poi-clothes-hov.svg',
	'/assets/public/images/map-markers/poi-food-hov.svg',
	'/assets/public/images/map-markers/poi-school-hov.svg',
	'/assets/public/images/map-markers/poi-sport-hov.svg',
	'/assets/public/images/map-markers/poi-med-hov.svg',
];

helpers.loadImages(hoverMarkers)
	.then((images) => {
		hoverMarkersLoaded = images;
	});

function initMaps(google) {
	// eslint-disable-next-line
	let mapStyles = [ { 'featureType': 'landscape', 'stylers': [ { 'saturation': -100 }, { 'lightness': 60 } ] }, { 'featureType': 'road.local', 'stylers': [ { 'saturation': -100 }, { 'lightness': 40 }, { 'visibility': 'on' } ] }, { 'featureType': 'transit', 'stylers': [ { 'saturation': -100 }, { 'visibility': 'simplified' } ] }, { 'featureType': 'administrative.province', 'stylers': [ { 'visibility': 'off' } ] }, { 'featureType': 'water', 'stylers': [ { 'visibility': 'on' }, { 'lightness': 30 } ] }, { 'featureType': 'road.highway', 'elementType': 'geometry.fill', 'stylers': [ { 'color': '#ef8c25' }, { 'lightness': 40 } ] }, { 'featureType': 'road.highway', 'elementType': 'geometry.stroke', 'stylers': [ { 'visibility': 'off' } ] }, { 'featureType': 'poi.park', 'elementType': 'geometry.fill', 'stylers': [ { 'color': '#b6c54c' }, { 'lightness': 40 }, { 'saturation': -40 } ] }, {} ];

	let map;
	let contactsBlockMap;
	let infowindow;
	let lastMarker;
	let markerCluster = null;
	let poiData = {};
	let poiMarkers = [];
	let geocoder = new google.maps.Geocoder();

	function codeAddress(address) {
		return new Promise((resolve) => {
			geocoder.geocode({address}, (results, status) => {
				if (status === google.maps.GeocoderStatus.OK) {
					resolve(results[0]);
				}
			});
		});
	}

	function appendMapEvents() {
		$('.map-controls__btn--zoomin').on('click', (e) => {
			$(e.currentTarget).blur();
			map.setZoom(map.getZoom() + 1);
		});

		$('.map-controls__btn--zoomout').on('click', (e) => {
			$(e.currentTarget).blur();
			map.setZoom(map.getZoom() - 1);
		});
	}

	function createPoiMarker(place) {
		let poiMarker = new google.maps.Marker({
			map,
			position: {
				lat: place.lat,
				lng: place.lng,
			},
			optimized: false,
			icon: {
				url: poiIconSet[place.icon],
				scaledSize: new google.maps.Size(48, 62),
			},
		});

		google.maps.event.addListener(poiMarker, 'click', function showPoiInfo() {
			infowindow.setContent(place.infoCont);
			poiMarker.setVisible(false);
			infowindow.open(map, this);
			lastMarker = poiMarker;
		});

		google.maps.event.addListener(poiMarker, 'mouseover', () => {
			poiMarker.setIcon({
				url: `${poiIconSet[place.icon].split('.svg')[0]}-hov.svg`,
				scaledSize: new google.maps.Size(48, 62),
			});
		});

		google.maps.event.addListener(poiMarker, 'mouseout', () => {
			poiMarker.setIcon({
				url: poiIconSet[place.icon],
				scaledSize: new google.maps.Size(48, 62),
			});
		});

		poiMarkers.push(poiMarker);
	}

	function placePoiMarkers(markers) {
		markers.forEach((curMarkerData) => {
			createPoiMarker(curMarkerData);
		});

		markerCluster = new MarkerClusterer(map, poiMarkers, {
			imagePath: '/assets/public/images/map-markers/poi',
		});
	}

	$('.map-places > ul').each((i, elem) => {
		let curPark = $(elem).data('park');

		poiData[curPark] = [];

		$(elem).find('li').each((j, node) => {
			let lat = $(node).data('lat');
			let lng = $(node).data('lng');
			let iconType = $(node).data('marker');
			let infoCont = $(node).html();

			let markerData = {
				lat,
				lng,
				icon: iconType,
				infoCont,
			};

			poiData[curPark].push(markerData);
		});
	});

	function initIndexMap() {
		let bounds = new google.maps.LatLngBounds();
		let georesults = {};
		let markers = [];

		function paneToMarker($btn, marker, lat, lng) {
			let btnDataLink = $btn.data('link');
			let btnDataPark = $btn.data('park');

			$btn.blur();

			markers.forEach((markerObj) => {
				markerObj.setIcon({
					url: '/assets/public/images/map-markers/placemark-black.svg',
					scaledSize: new google.maps.Size(44, 58),
				});

				google.maps.event.addListener(markerObj, 'mouseover', () => {
					markerObj.setIcon({
						url: '/assets/public/images/map-markers/placemark-black-hov.svg',
						scaledSize: new google.maps.Size(44, 58),
					});
				});

				google.maps.event.addListener(markerObj, 'mouseout', () => {
					markerObj.setIcon({
						url: '/assets/public/images/map-markers/placemark-black.svg',
						scaledSize: new google.maps.Size(44, 58),
					});
				});
			});

			marker.setIcon({
				url: '/assets/public/images/map-markers/placemark.svg',
				scaledSize: new google.maps.Size(44, 58),
			});

			google.maps.event.addListener(marker, 'mouseover', () => {
				marker.setIcon({
					url: '/assets/public/images/map-markers/placemark-hov.svg',
					scaledSize: new google.maps.Size(44, 58),
				});
			});

			google.maps.event.addListener(marker, 'mouseout', () => {
				marker.setIcon({
					url: '/assets/public/images/map-markers/placemark.svg',
					scaledSize: new google.maps.Size(44, 58),
				});
			});

			map.panTo({
				lat,
				lng,
			});

			// show poi

			if (markerCluster) {
				markerCluster.removeMarkers(poiMarkers);
			}
			poiMarkers.forEach((poiMarkerElem) => {
				poiMarkerElem.setMap(null);
				poiMarkerElem = null;
			});
			poiMarkers.length = 0;

			placePoiMarkers(poiData[btnDataPark]);

			$('.map-goto').attr('href', btnDataLink);

			$('.map-nav__btn').removeClass('is-current');
			$btn.addClass('is-current');
		}

		map = new google.maps.Map($('.parks-map')[0], {
			disableDefaultUI: true,
			mapTypeControl: false,
			zoom: 14,
			styles: mapStyles,
		});

		$('.index-map__addr').each((i, elem) => {
			let lat = $(elem).data('lat');
			let lng = $(elem).data('lng');

			georesults[i] = {
				lat,
				lng,
			};

			let marker = new google.maps.Marker({
				map,
				position: {
					lat,
					lng,
				},
				optimized: false,
				icon: {
					url: '/assets/public/images/map-markers/placemark-black.svg',
					scaledSize: new google.maps.Size(44, 58),
				},
				zIndex: 9999999,
			});

			google.maps.event.addListener(marker, 'click', () => {
				let $button = $(`.map-nav__btn[data-addr="${i + 1}"]`);

				paneToMarker($button, marker, lat, lng);
			});

			google.maps.event.addListener(marker, 'mouseover', () => {
				marker.setIcon({
					url: '/assets/public/images/map-markers/placemark-black-hov.svg',
					scaledSize: new google.maps.Size(44, 58),
				});
			});

			google.maps.event.addListener(marker, 'mouseout', () => {
				marker.setIcon({
					url: '/assets/public/images/map-markers/placemark-black.svg',
					scaledSize: new google.maps.Size(44, 58),
				});
			});

			markers.push(marker);

			bounds.extend(marker.getPosition());
			if (i === $('.index-map__addr').length - 1) {
				map.fitBounds(bounds);
			}

			if (i === 0) {
				let $btn = $(`.map-nav__btn[data-addr="${i + 1}"]`);

				paneToMarker($btn, marker, lat, lng);
			}

			$(`.map-nav__btn[data-addr="${i + 1}"]`).on('click', (e) => {
				let $btn = $(e.currentTarget);

				$btn.blur();
				paneToMarker($btn, marker, lat, lng);
			});
		});

		appendMapEvents();
	}

	function initParkMap() {
		let iconLink;
		let curPark;
		let lat = $('.park-map__addr').data('lat');
		let lng = $('.park-map__addr').data('lng');

		if ($('.park-map').data('park') === 'futuro') {
			iconLink = '/assets/public/images/map-markers/placemark-futuro.svg';
			curPark = 'futuro';
		}
		if ($('.park-map').data('park') === 'fonte') {
			iconLink = '/assets/public/images/map-markers/placemark-fonte.svg';
			curPark = 'fonte';
		}
		if ($('.park-map').data('park') === 'avenue') {
			iconLink = '/assets/public/images/map-markers/placemark-avenue.svg';
			curPark = 'avenue';
		}

		map = new google.maps.Map($('.park-map__container__inner')[0], {
			disableDefaultUI: true,
			mapTypeControl: false,
			center: {
				lat,
				lng,
			},
			zoom: 14,
			styles: mapStyles,
		});

		// eslint-disable-next-line
		let marker = new google.maps.Marker({
			map,
			position: {
				lat,
				lng,
			},
			title: $('.park-map__addr').text(),
			icon: {
				url: iconLink,
				scaledSize: new google.maps.Size(44, 58),
			},
			zIndex: 999999,
		});

		// show poi
		placePoiMarkers(poiData[curPark]);

		appendMapEvents();
	}

	function initContactsMap() {
		let bounds = new google.maps.LatLngBounds();
		let georesults = {};

		$('.contacts-address').each((i, elem) => {
			let lat = $(elem).data('lat');
			let lng = $(elem).data('lng');

			georesults[i] = {
				lat,
				lng,
			};

			if (i === 0) {
				map = new google.maps.Map($('.contacts-map__container__inner')[0], {
					disableDefaultUI: true,
					mapTypeControl: false,
					center: {
						lat,
						lng,
					},
					zoom: 11,
					styles: mapStyles,
				});
			}

			let marker = new google.maps.Marker({
				map,
				position: {
					lat,
					lng,
				},
				title: $(elem).find('.contacts-address__link').text(),
				optimized: false,
				icon: {
					url: i === 0 ? '/assets/public/images/map-markers/placemark.svg' : '/assets/public/images/map-markers/placemark-black.svg',
					scaledSize: new google.maps.Size(44, 58),
				},
			});

			google.maps.event.addListenerOnce(map, 'bounds_changed', () => {
				map.setZoom(11);
			});

			bounds.extend(marker.getPosition());
			if (i === $('.contacts-address__link').length - 1) {
				map.fitBounds(bounds);
			}

			$(elem).on('click', (e) => {
				e.preventDefault();

				let $btn = $(e.currentTarget);

				$btn.blur();

				map.panTo({
					lat,
					lng,
				});

				map.setZoom(17);
			});
		});

		appendMapEvents();
	}

	function initContactsBlockMap() {
		let contBlockMarkers = [];
		let iconLink = '/assets/public/images/map-markers/placemark.svg';

		let mapShowAnim = {
			show() {
				new TimelineMax()
					.to($('.index-contacts__media__shim'), 0.5, {
						scaleY: 1,
						ease: 'easeBoth',
					})
					.to($('.index-contacts__media__bg .before-like'), 0.4, {
						scaleY: 1,
						ease: 'easeBoth',
					}, 0.2)
					.to($('.index-contacts__media__shim'), 0.4, {
						onStart() {
							$('.index-contacts__map').addClass('is-visible');
						},
						opacity: 0,
						ease: 'default',
					}, 0.4);
			},

			hide() {
				new TimelineMax({
					onComplete() {
						TweenMax.set([
							$('.index-contacts__media__shim'),
							$('.index-contacts__media__bg .before-like'),
						], {
							clearProps: 'opacity, transform',
						});
					},
				})
					.to($('.index-contacts__media__shim'), 0.2, {
						opacity: 1,
						ease: 'default',
						onComplete() {
							$('.index-contacts__map').removeClass('is-visible');
						},
					})
					.to($('.index-contacts__media__bg .before-like'), 0.4, {
						scaleY: 0,
						ease: 'easeBoth',
					}, 0.1)
					.to($('.index-contacts__media__shim'), 0.5, {
						scaleY: 0,
						ease: 'easeBoth',
					}, 0.2);
			},
		};

		if ($('body').hasClass('park-futuro')) {
			iconLink = '/assets/public/images/map-markers/placemark-futuro.svg';
		}
		if ($('body').hasClass('park-fonte')) {
			iconLink = '/assets/public/images/map-markers/placemark-fonte.svg';
		}
		if ($('body').hasClass('park-avenue')) {
			iconLink = '/assets/public/images/map-markers/placemark-avenue.svg';
		}

		$('.index-contacts__map__close').on('click', (e) => {
			$(e.currentTarget).blur();
			mapShowAnim.hide();
		});

		contactsBlockMap = new google.maps.Map($('.index-contacts__map__container')[0], {
			mapTypeControl: false,
			zoom: 11,
			center: {
				lat: $($('.index-contacts__maplink')[0]).data('lat'),
				lng: $($('.index-contacts__maplink')[0]).data('lng'),
			},
			styles: mapStyles,
		});

		$('.index-contacts__maplink').each((i, elem) => {
			let marker = new google.maps.Marker({
				contactsBlockMap,
				position: {
					lat: $(elem).data('lat'),
					lng: $(elem).data('lng'),
				},
				optimized: false,
				icon: {
					url: '/assets/public/images/map-markers/placemark-black.svg',
					scaledSize: new google.maps.Size(44, 58),
				},
			});

			marker.setMap(contactsBlockMap);

			contBlockMarkers.push(marker);

			$(elem).on('click', (e) => {
				$(e.currentTarget).blur();

				contBlockMarkers.forEach((contMarker) => {
					contMarker.setIcon({
						url: '/assets/public/images/map-markers/placemark-black.svg',
						scaledSize: new google.maps.Size(44, 58),
					});
				});

				marker.setIcon({
					url: iconLink,
					scaledSize: new google.maps.Size(44, 58),
				});

				contactsBlockMap.panTo({
					lat: $(elem).data('lat'),
					lng: $(elem).data('lng'),
				});

				if (!$('.index-contacts__map').hasClass('is-visible')) {
					mapShowAnim.show();
				} else {
					mapShowAnim.hide();
				}
			});
		});
	}

	// load infobox
	let script = document.createElement('script');

	script.onload = () => {
		infowindow = new InfoBox({
			alignBottom: true,
			maxWidth: 172,
			boxStyle: {
				opacity: 1,
				zIndex: 999,
				width: '172px',
			},
			closeBoxURL: '/assets/public/images/map-markers/cross.svg',
		});

		infowindow.addListener('closeclick', () => {
			lastMarker.setVisible(true);
		});

		infowindow.addListener('content_changed', () => {
			if (lastMarker) {
				lastMarker.setVisible(true);
			}
		});

		if ($('.index-map').length) {
			initIndexMap();
		}

		if ($('.park-map').length) {
			initParkMap();
		}

		if ($('.contacts-map').length) {
			initContactsMap();
		}

		if ($('.index-contacts__map').length) {
			initContactsBlockMap();
		}
	};

	script.src = '/assets/public/js/infobox.js';
	document.body.appendChild(script);
}

// load maps API and init
googleMapsLoader.KEY = 'AIzaSyBqQYDwK7AMPztNI_-7_vKsRohx0f32fhc';
googleMapsLoader.LANGUAGE = 'ru';
googleMapsLoader.LIBRARIES = ['places'];

if (helpers.isHeroShown) {
	googleMapsLoader.load(initMaps);
} else {
	$(document).one('hero.isShown', () => {
		googleMapsLoader.load(initMaps);
	});
}
